import React, {
    FC,
} from 'react';

import styles from './Footer.module.scss';

const Footer: FC = () => {
    return (
        <div className={styles.footer}>
            <div className={styles.logo}>
                IT SPORT
            </div>
        </div>
    );
};

export default Footer;
